import React, { useState } from 'react';
import styled from 'styled-components';

import TabsNavigation from '#/components/basic/Button/TabsNavigation';
import ChartsRouter from '#/components/chart/ChartsRouter';
import { ChartsRouterSection } from '#/components/chart/chartsRouterTypes';
import MarketHeader from '#/components/markets/MarketHeader';
import { getOrderbookSectionHeight } from '#/components/orders/orderBook/orderBookRowUtils';
import OrderbookSection from '#/components/orders/orderBook/OrderbookSection';
// import { FavoritesBar } from '#/components/settings/favorites/FavoritesBar';
import BuySellPanelWrap from '#/components/trading/BuySellPanel/BuySellPanelWrap';
import TradesTable from '#/components/trading/TradesTable';
import { useSelector } from '#/reduxState/storeCore';

import DashboardBottomTabs from './DashboardBottomTabs';

const MainGrid = styled.div<{ $verticalResolutionIndex: number }>`
  width: 100%;
  min-height: 100%;
  display: grid;
  /* TODO: 260px width ? */
  grid-template-columns: 1fr 266px 266px;
  grid-template-rows: ${({ $verticalResolutionIndex }) =>
      getOrderbookSectionHeight($verticalResolutionIndex)}px minmax(400px, 1fr);
  grid-template-areas:
    'areaChart areaOrderbook areaBuysell'
    'areaTabs areaTabs areaBuysell';
  gap: 4px;
  padding: 4px;
`;

const SidebarBlock = styled.div`
  grid-area: areaBuysell;
`;

const ChartWrap = styled.div`
  grid-area: areaChart;

  display: grid;
  grid-template-columns: 1fr;
  /* With <FavoritesBar />: grid-template-rows: min-content min-content 1fr; */
  grid-template-rows: min-content 1fr;
  gap: 4px;
`;

const TradesAndOrderbookWrap = styled.div`
  grid-area: areaOrderbook;

  /* To make it easiy for browser to recalculate */
  overflow: hidden;
  background: var(--elevation-light);
  border-radius: 2px;

  display: flex;
  flex-direction: column;
`;

function DashboardDesktop() {
  const verticalResolutionIndex = useSelector(
    state => state.screen.verticalResolutionIndex
  );
  const [section, setSection] = useState<ChartsRouterSection>('chart');

  const [activeTab, setActiveTab] = useState<'orderbook' | 'trades'>(
    'orderbook'
  );

  return (
    <MainGrid $verticalResolutionIndex={verticalResolutionIndex}>
      <ChartWrap>
        {/* <FavoritesBar /> */}
        <MarketHeader />
        <ChartsRouter onChange={setSection} section={section} />
      </ChartWrap>

      <TradesAndOrderbookWrap>
        <TabsNavigation
          buttons={[
            {
              title: 'Orderbook',
              onClick: () => setActiveTab('orderbook'),
              active: activeTab === 'orderbook',
              stretch: true,
            },
            {
              title: 'Trades',
              onClick: () => setActiveTab('trades'),
              active: activeTab === 'trades',
              stretch: true,
            },
          ]}
        />
        {activeTab === 'trades' && <TradesTable />}
        {activeTab === 'orderbook' && <OrderbookSection />}
      </TradesAndOrderbookWrap>

      <SidebarBlock>
        <BuySellPanelWrap />
      </SidebarBlock>

      <DashboardBottomTabs />
    </MainGrid>
  );
}

export default DashboardDesktop;
